export const INTERNAL_AUTH_MERCHANTS: string[] = [];
